export const eraseShape = (object) => {
  if (object.pk_type !== 'background') {
    window.canvas.remove(object)
  }
}
